import {
  clearPwaDeferredInstallPrompt,
  getPwaDeferredInstallPrompt,
} from 'utils/usePwaDeferredInstallPrompt';
import { isIosDevice, isSamsungInternetBrowser } from 'utils/pwa';

export type PwaInstallFlowResult =
  | { type: 'android-started' }
  | { type: 'ios-guide' }
  | { type: 'android-manual' }
  | { type: 'use-chrome' };

/**
 * Run from a click/tap handler so Android can show the native install sheet.
 * Must not be deferred to useEffect (breaks user-gesture requirement).
 */
export async function runPwaInstallFromUserGesture(): Promise<PwaInstallFlowResult> {
  if (isIosDevice()) {
    return { type: 'ios-guide' };
  }

  // Samsung Internet WebAPK → Play Protect “unsafe / old Android” warning.
  // Do not fire the native install prompt; guide the user to Chrome.
  if (isSamsungInternetBrowser()) {
    return { type: 'use-chrome' };
  }

  const prompt = getPwaDeferredInstallPrompt();
  // Chromium (Android phone/tablet, desktop Chrome) — fire native install while gesture is live.
  if (prompt) {
    try {
      await prompt.prompt();
      await prompt.userChoice;
    } catch {
      // User dismissed the system sheet.
    }
    clearPwaDeferredInstallPrompt();
    return { type: 'android-started' };
  }

  return { type: 'android-manual' };
}
